import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AlertConfig } from '../user.service';
import { environment } from 'src/environments/environment';

export type AlertCampaignRosterLine = {
  subject: string;
  phone: string;
  skipped?: boolean;
};

export type AlertCampaignStartRequest = {
  title: string;
  description?: string;
  locationId: string;
  alertConfig: AlertConfig;
  customSchedule?: { date: string; time: string }[];
  roster: AlertCampaignRosterLine[];
};

export type AlertCampaignStartResult = {
  campaignId: string;
  recordsRequested: number;
  recordsSkipped: number;
  sequencesCreated: number;
  sequencesDispatched: number;
  dispatchErrors: number;
};

export type AlertCampaignSummary = {
  id: string;
  title: string;
  description?: string;
  createdDate: number;
  alertConfig?: AlertConfig;
};

export type AlertCampaignListItem = {
  id: string;
  title: string;
  createdDate: number;
};

@Injectable({ providedIn: 'root' })
export class AlertCampaignService {
  #http = inject(HttpClient);

  startCampaign(body: AlertCampaignStartRequest): Observable<AlertCampaignStartResult> {
    const url = `${environment.urls.standaloneApi}/v1/organization/alert-campaign/start`;
    return this.#http.post<AlertCampaignStartResult>(url, body);
  }

  getCampaign(campaignId: string): Observable<AlertCampaignSummary> {
    const url = `${environment.urls.standaloneApi}/v1/organization/alert-campaign/${encodeURIComponent(campaignId)}`;
    return this.#http.get<AlertCampaignSummary>(url);
  }

  listCampaigns(): Observable<{ result: AlertCampaignListItem[] }> {
    const url = `${environment.urls.standaloneApi}/v1/organization/alert-campaigns`;
    return this.#http.get<{ result: AlertCampaignListItem[] }>(url);
  }
}
